module.exports = __webpack_public_path__ + "media/images/nn_logo_small-42bc9e9b4ffaf454c2cf67f1d06db111.svg";